import { render, staticRenderFns } from "./BacktestSection.vue?vue&type=template&id=913e60ac&scoped=true&"
import script from "./BacktestSection.vue?vue&type=script&lang=js&"
export * from "./BacktestSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913e60ac",
  null
  
)

export default component.exports